// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nrAb9","newExpiryDate":"styles_newExpiryDate__36pHr","footer":"styles_footer__1WTlA"};